var map = {
	"./asean.webp": "./src/assets/images/flags/asean.webp",
	"./co.webp": "./src/assets/images/flags/co.webp",
	"./dr.webp": "./src/assets/images/flags/dr.webp",
	"./id.webp": "./src/assets/images/flags/id.webp",
	"./kh.webp": "./src/assets/images/flags/kh.webp",
	"./mx.webp": "./src/assets/images/flags/mx.webp",
	"./pe.webp": "./src/assets/images/flags/pe.webp",
	"./ph.webp": "./src/assets/images/flags/ph.webp",
	"./th.webp": "./src/assets/images/flags/th.webp",
	"./vn.webp": "./src/assets/images/flags/vn.webp",
	"./zh.webp": "./src/assets/images/flags/zh.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/flags sync recursive ^\\.\\/.*\\.webp$";